const OnTheStrength = (props) => {
    return (
        <div className="lyrics eggshell">
            <h2>On the Strength of all Conviction and the Stamina of Love</h2>
            <h4>Jennifer Michael Hecht</h4>
            <p>Sometimes I think<br/>
            we could have gone on.<br/>
            All of us. Trying. Forever.<br/>
            <br/>
            But they didn't fill<br/>
            the desert with pyramids.<br/>
            They just built some. Some.<br/>
            <br/>
            They're not still out there,<br/>
            building them now. Everyone,<br/>
            everywhere, gets up, and goes home.<br/>
            <br/>
            Yet we must not<br/>
            diabolize time. Right?<br/>
            We must not curse the passage of time.<br/>
            <br/>
            <small>Reprinted with permission.<br/>&copy;Jennifer Michael Hecht. All Rights Reserved</small>
            </p>
        </div>
    )
}
export default OnTheStrength;